import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMedia } from '@/hooks/responsive';
import { usePlans } from '@/hooks/price';
import PlanCardUnified from '@/components/PlanCardUnified';

export function Payment() {
	const { t } = useTranslation();
	const mdDown = useMedia('mdDown');

	const plansData = usePlans();

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				gap: '16px',
				margin: '40px auto',
				width: '100%',
				textAlign: 'center',
				alignItems: 'center',
				padding: mdDown ? '0px 20px 40px 20px' : 'unset'
			}}
		>
			<Typography variant={mdDown ? 'body3' : 'h2'} sx={{ fontWeight: 500 }}>
				{t('unsubscribe.payment.title')}
			</Typography>
			<Typography
				variant={mdDown ? 'body1' : 'body3'}
				sx={{
					maxWidth: '793px',
					margin: mdDown ? '8px auto' : '24px auto'
				}}
			>
				{t('unsubscribe.payment.subtitle')}
			</Typography>
			<Box
				sx={{
					display: 'flex',
					gap: '16px',
					flexDirection: 'row',
					flexWrap: 'wrap',
					justifyContent: 'center',
					textAlign: 'left',
					alignItems: 'flex-start'
				}}
			>
				<PlanCardUnified plansData={plansData} isUnsubscribe />
			</Box>
		</Box>
	);
}
